import React from 'react';
import styled from 'styled-components';

interface ISearchIconProps {
  user?: 'landlord' | 'tenant';
}

const StyledSvg = styled.svg<ISearchIconProps>`
  display: block;

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

const Search = ({ user = 'landlord' }: ISearchIconProps): JSX.Element => (
  <StyledSvg
    user={user}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
  >
    <path
      d="M37.816 33.914l-6.641-6.641a.717.717 0 00-.992-.992l-1.772-1.772a14.489 14.489 0 002.4-6.62 14.519 14.519 0 00-2.216-9.286.716.716 0 00-1.205.775c3.29 5.115 2.55 11.953-1.756 16.26-5.083 5.083-13.354 5.083-18.437 0-5.083-5.083-5.083-13.354 0-18.437 4.312-4.311 10.932-5.075 16.1-1.857a.716.716 0 00.758-1.217 14.531 14.531 0 00-9.21-2.092 14.507 14.507 0 00-8.66 4.153C.542 11.83.542 21.01 6.184 26.651a14.424 14.424 0 0010.23 4.231c2.823 0 5.646-.82 8.078-2.457l1.763 1.764a.716.716 0 001.011 1.011l6.632 6.631c.533.534 1.235.8 1.939.8.71 0 1.422-.27 1.964-.813 1.08-1.08 1.087-2.832.014-3.904zm-11.845-6.037l1.891-1.891 1.298 1.297-1.892 1.892-1.297-1.297zm10.818 8.927a1.33 1.33 0 01-1.877.014l-6.63-6.63 1.89-1.892 6.631 6.63a1.33 1.33 0 01-.014 1.878z"
      fill="#000"
    />
    <path
      d="M26.662 6.205l-.016-.015A.716.716 0 0025.63 7.2l.019.018a.714.714 0 001.013 0 .716.716 0 000-1.013zM16.414 5.389c-6.083 0-11.031 4.948-11.031 11.03 0 6.083 4.948 11.032 11.03 11.032 6.083 0 11.032-4.949 11.032-11.031 0-6.083-4.949-11.031-11.031-11.031zm0 20.63c-5.293 0-9.599-4.307-9.599-9.6 0-5.292 4.306-9.598 9.599-9.598 5.292 0 9.598 4.306 9.598 9.599 0 5.292-4.306 9.598-9.598 9.598z"
      fill="#000"
    />
  </StyledSvg>
);

export default Search;
